module.exports = __webpack_public_path__ + "img/dianhuatianchong.9648d368.svg";